import { Layout,Menu, message } from "antd";
import { useCallback, useEffect, useRef, useState } from "react";
import { useLocation, useParams } from "react-router-dom"
import InstituteData from "./InstituteData";
import InstituteCoordinator from "./InstituteCoordinator";
import InstituteInformation from "./InstituteInformation";
import PermissionInstitute from "./../Permission Letter/PermissionInstitute";
import InstituteService from "../../../services/InstituteService";

import ImagePerfil from "../../../Assets/ImagePerfil.jpg"
import LogoUcatolica from "../../../Assets/LogoUcatolica.jpg"

const {Sider,Content}=Layout;

const imagePerfil=ImagePerfil;
// const imageBackground="https://upload.wikimedia.org/wikipedia/commons/1/1f/Ucatolica2.jpg";
//const imagePerfil="https://i.pinimg.com/originals/49/c8/e4/49c8e403cd1929e9e7b02126824ff831.jpg";

export default function InstituteDetails() {
    const params=useParams();
    const instituteId=params.id;
    const location=useLocation();
    const instituteLocation=location?.state?.instituteSelect;
    const [instituteSelect,setInstituteSelect]=useState([]);
    const [selectedMenuItem,setSelectedMenuItem]=useState("InstituteData")
    const [updateInstituteLogo,setUpdateInstituteLogo]=useState(false);  
    const [instituteLogo,setInstituteLogo]=useState({
        id:"",
        logoInstitute: "",
    });  
    const { current: query } = useRef(new URLSearchParams(useLocation().search));

    
    

    const getOneInstituteById=useCallback((InstituteId)=>{
        InstituteService.getOneInstituteInformationByCenter(InstituteId).then((res)=>{
            // console.log("res",res)
            // console.log("instituteLocation",instituteLocation)
            if (instituteLocation==null) {
                let {response,success}=res.data
                // console.log("instituteInfo",response)
                if(success){
                    console.log("instituteLocationSuccess")
                    setInstituteSelect(response)
                }
                else{
                    message.error("no se pudo obtener la información del instituto")
                }
            }else{
                setInstituteSelect(instituteLocation)
            }
        })
    })

    const getLogoByInstitute=useCallback((instituteID)=>{
        InstituteService.getLogoByInstitute(instituteID).then((res)=>{
            let {response,success}=res.data
            if(success){
                // console.log(response)
                response.logoInstitute!=null?
                setInstituteLogo(response): setInstituteLogo({
                        id:instituteID,
                        logoInstitute:null,
                    })
            }
            else{
                message.error("No se pudo obtener el logo del insituto")
            }
            setUpdateInstituteLogo(false)
        })
    });

    
    const updateLogoByInstitute=(value)=>{
        setUpdateInstituteLogo(value)
    }


    useEffect(()=>{
        getOneInstituteById(instituteId)
        getLogoByInstitute(instituteId)
        if(query.get("option")!=null){
            console.log(query.get("option"))
            setSelectedMenuItem(query.get("option"))
        }
    },[])

    useEffect(()=>{
        // console.log("updateInstituteLogo",updateInstituteLogo)
        // console.log("instituteId",instituteId)   
        getLogoByInstitute(instituteId)
    },[updateInstituteLogo])

    const switChOptionsMenu=(option)=>{
        switch (option) {
            case "InstituteData":
                return <InstituteData 
                Body={instituteSelect} 
                updateLogoByInstitute={updateLogoByInstitute} 
                InstituteLogo={instituteLogo}
                DefaultLogo={LogoUcatolica}
                />

            case "CoordinatorData":
                return <InstituteCoordinator 
                Body={instituteSelect}
                InstituteLogo={instituteLogo}
                DefaultLogo={LogoUcatolica}
                DefaultProfile={imagePerfil}
                />

            case "DataMisionAndVision":
                return <InstituteInformation Body={instituteSelect}></InstituteInformation>

            case "PermissionLetter":
                    return <PermissionInstitute Institute={instituteSelect}></PermissionInstitute>

        }
    }

    return(<>
    <Layout style={{margin:30, gap:15}} >
        <Sider 
        breakpoint="lg"
        style={{backgroundColor:"transparent"}}
        >
            <Menu 
            mode="inline"
            onClick={(e)=>{setSelectedMenuItem(e.key)}}
            defaultSelectedKeys={[selectedMenuItem]}
            defaultOpenKeys={["List"]}
            className="ContainerOfMenuOptions">   
                            <Menu.Item key={"InstituteData"}>
                                    Datos generales
                                </Menu.Item>
                                <Menu.Item key={"CoordinatorData"}>
                                    Coordinador encargado
                                </Menu.Item>
                                <Menu.Item key={"DataMisionAndVision"}>
                                    Objetivos del instituto
                                </Menu.Item>
                                <Menu.Item key={"PermissionLetter"}>
                                    Carta de permiso de funcionamiento
                                </Menu.Item>
                            </Menu>
        </Sider>
            <Layout>
            <Content className="ContainerOfMenuOptions">
                    {switChOptionsMenu(selectedMenuItem)}
            </Content>
            </Layout>
    </Layout>
    </>)
    
}